import type { RowSelectionOptions, SelectionColumnDef } from 'ag-grid-community';

import { leadingEdge } from '@/components/AgGrid/helpers/gridEdges';

// Rows are selected through AG Grid's checkbox column (row and header checkboxes), never by clicking a row.
export const CHECKBOX_ROW_SELECTION: RowSelectionOptions = {
  mode: 'multiRow',
  checkboxes: true,
  headerCheckbox: true,
  enableClickSelection: false,
};

// The checkbox column at the start of the row, at a fixed width the user can neither change nor unpin.
export const getSelectionColumnDef = (enableRtl: boolean, width: number): SelectionColumnDef => ({
  pinned: leadingEdge(enableRtl),
  lockPinned: true,
  width,
  minWidth: width,
  maxWidth: width,
  resizable: false,
  suppressSizeToFit: true,
});
